<template>
  <div
    class="company-search-results"
    v-if="searchResult.length > 0 || searchHeader"
  >
    <div class="company-search-results__header-container" v-if="searchHeader">
      <p class="company-search-results__header" v-if="searchHeader">
        {{ searchHeader }}
      </p>
      <p class="company-search-results__section-header"></p>
    </div>
    <div class="company-card" v-for="result in searchResult" :key="result.id">
      <a
        class="company-card__link"
        v:on-click="saveInState"
        v-bind:href="result.url"
      >
        <div class="company-card__left-container">
          <div class="company-card__count-bauble">
            <div class="company-card__count-bauble--text">
              {{ result.adCount }}
            </div>
          </div>
          <p><small>annoncer</small></p>
        </div>
        <div class="company-card__right-container">
          <div class="company-card__info">
            <h3 class="company-card__info-title">
              <strong v-html="result.name"></strong>
            </h3>
            <p class="company-card__info-text" v-html="result.address"></p>
            <p class="company-card__info-text" v-html="result.zipAndCity"></p>
          </div>
          <Arrow direction="right" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'

import Arrow from '@shared/Arrow/Arrow.vue'

export default {
  props: {
    uiProp: { default: null, type: Object },
    searchResultProp: { default: null, type: Array },
    searchHeaderProp: { default: '', type: String },
  },
  data() {
    return {
      searchResult: Array,
      searchHeader: '',
    }
  },
  components: {
    Arrow,
  },
  mounted() {
    this.getFromState()
  },
  methods: {
    saveInState() {
      window.history.replaceState(
        JSON.parse(
          JSON.stringify({
            searchResult: this.searchResult,
            searchHeader: this.searchHeader,
          })
        ),
        '',
        null
      )
    },
    getFromState() {
      if (window.history.state === null) return

      const searchHeader = window.history.state.searchHeader
      const searchResult = window.history.state.searchResult

      nextTick(() => {
        this.searchHeader = searchHeader
        this.searchResult = searchResult
      })
    },
    closeOverlay() {
      if (app.history.getStackSize != 0) {
        app.history.pop()
      }
    },
  },
  watch: {
    searchResultProp(value) {
      this.searchResult = value
    },
    searchHeaderProp(value) {
      this.searchHeader = value
    },
  },
}
</script>

<style lang="scss">
@import 'CompanySearchResults.scss';
</style>
